import { forwardRef } from "react"
import classNames from "classnames"
import { mergeClasses } from "@lib/css"

import type {
  TextareaHTMLAttributes,
  InputHTMLAttributes,
  ElementType,
} from "react"

type TextFieldElement = HTMLInputElement | HTMLTextAreaElement

type TextFieldProps = {
  as?: ElementType
  className?: string
} & InputHTMLAttributes<TextFieldElement> &
  TextareaHTMLAttributes<HTMLAnchorElement>

export const TextField = forwardRef<TextFieldElement, TextFieldProps>(
  function TextField(props, ref) {
    const {
      as: Element = "input",
      children,
      className,
      type = "text",
      "aria-invalid": ariaInvalid,
      ...otherProps
    } = props

    const defaultClasses = classNames(
      "px-2 h-16 font-sans text-lg text-black border border-t-transparent border-r-transparent border-l-transparent border-b-gray-150 placeholder-gray-200 transition-colors resize-none",
      "focus:ring-0 focus:border-t-transparent focus:border-r-transparent focus:border-l-transparent focus:border-b-black",
      {
        "text-red-300 border-b-red-300 placeholder-red-300 focus:border-b-red-300": ariaInvalid,
      },
    )

    const classes = mergeClasses(defaultClasses, className)

    return (
      <Element
        ref={ref}
        type={type}
        aria-invalid={ariaInvalid}
        className={classes}
        {...otherProps}
      />
    )
  },
)
